
define('text!maintenance/controllers/SiteMaintenancePage.html',[],function () { return '<div data-cms-spot data-spot-name="siteMaintenance"></div>\n';});

